import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Div, Input, InputDecimal, DropDownList, CheckerBox } from "../../core"
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TablePagination from "@material-ui/core/TablePagination"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import moment from 'moment'
import head_service_line from '../datas/head_service_line.json'
import {
    data_t_GR_SERVICELINE
} from '../../../configs/datas'

import utilityHelper from '../../../helpers/helperUtil'
import tableHelper from '../../../helpers/tableHelper'
import { msg } from "../../Notifications/MsgBox/index.js"
import {
    EVENT_CURRENT_SERVICELINE_SELECTED
} from '../../../configs/EventTypes'

const numeral = require('numeral')

class ServiceLineList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            local_t_GR_SERVICE: [],
            local_t_GR_SERVICELINE: [],
            serviceItemNo: null,
            serviceline_checkall: false,
            serviceline_render: data_t_GR_SERVICELINE,
            head_serviceLine: head_service_line,
            order_serviceLine: "asc",
            orderBy_serviceLine: "",
            selected_serviceLine: [],
            page_serviceLine: 0,
            rowsPerPage_serviceLine: 10,
        }

        this.handleSelectAllClick = this.handleSelectAllClick.bind(this)
        this.handleChangeServiceLine = this.handleChangeServiceLine.bind(this)
        this.getUnitUOM = this.getUnitUOM.bind(this)
        this.filterServiceLine = this.filterServiceLine.bind(this)
        this.setServiceLineModal = this.setServiceLineModal.bind(this)
        this.setHeaderCheckAll = this.setHeaderCheckAll.bind(this)
        this.getLastServiceLineNo = this.getLastServiceLineNo.bind(this)


        window.onShowServiceline = this.handleClick.bind(this)
        this.loadServiceLineByPopupServiceline = this.loadServiceLineByPopupServiceline.bind(this)
        window.onServiceLineSaved = this.loadServiceLineByPopupServiceline.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        let {
            serviceItemNo,
            t_GR_SERVICE,
            t_GR_SERVICELINE
        } = this.props

        if (t_GR_SERVICE != nextProps.t_GR_SERVICE) {
            this.setState({
                local_t_GR_SERVICE: [...nextProps.t_GR_SERVICE]
            })
        }

        if (t_GR_SERVICELINE != nextProps.t_GR_SERVICELINE) {
            this.setState({
                local_t_GR_SERVICELINE: [...nextProps.t_GR_SERVICELINE]
            })
            this.filterServiceLine(nextProps.serviceItemNo, nextProps.t_GR_SERVICE, nextProps.t_GR_SERVICELINE)
        }
        if (serviceItemNo != nextProps.serviceItemNo) {
            this.setState({
                serviceItemNo: nextProps.serviceItemNo
            })

            this.filterServiceLine(nextProps.serviceItemNo, nextProps.t_GR_SERVICE, nextProps.t_GR_SERVICELINE)
        }
    }

    handleSelectAllClick(event) {
        if (!event) return

        let {
            serviceItemNo,
            local_t_GR_SERVICE,
            local_t_GR_SERVICELINE,
            overall_limit
        } = this.state
        const { t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT } = this.props

        const checked = event.target && event.target.checked ? 1 : 0

        local_t_GR_SERVICELINE.filter(item =>(Number(item.service_item_no) === Number(serviceItemNo)) )
            .map((item, index) => {
                if (Number(item.remaining_qty) > 0) {
                    item.checked = checked
                }
                else if (Number(item.remaining_qty) == 0 && Number(overall_limit) > 0 ) {
                    item.checked = checked
                }
            })

        t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.map((item, _index) => {
            if (item.item_no == serviceItemNo) {
                let hasServiceLine = local_t_GR_SERVICELINE.some(f => f.service_line_no == item.service_line_no && f.service_item_no == item.item_no)
                if(hasServiceLine) {
                    item.checked = checked
                }
            }
        })


        this.filterServiceLine(serviceItemNo, local_t_GR_SERVICE, local_t_GR_SERVICELINE)
    }

    filterServiceLine(serviceItemNo, props_t_GR_SERVICE, props_t_GR_SERVICELINE) {
        let _serviceline = props_t_GR_SERVICELINE.filter((data) => {
            return (data.service_item_no && (data.service_item_no + '' === serviceItemNo + ''))
        })

        if (_serviceline || _serviceline.length === 0) {
            this.setState({
                serviceline_render: _serviceline
            })
        }

        this.setState({
            showServiceLine: props_t_GR_SERVICE && props_t_GR_SERVICE.some(f => f.checked == 1)
        })

        this.setHeaderCheckAll(serviceItemNo)
    }

    handleClick(event, index, selected_serviceLine, service_item_no, service_line_no) {
        if (!event) return
        const { onSelectServiceLine, t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT } = this.props

        let checked = event.target.checked ? 1 : 0

        if (onSelectServiceLine) {
            t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.map((item, _index) => {
                if (item.service_line_no + "" == service_line_no + "" && item.item_no == service_item_no) {
                    item.checked = checked
                }
            })
            onSelectServiceLine(index, checked)
        }
        let { serviceItemNo } = this.state
        this.setHeaderCheckAll(serviceItemNo)
    }

    getUnitUOM() {
        let result = null
        const { unit_uom } = this.props

        if (unit_uom) {
            result = utilityHelper.toSelectList_CombineFields(unit_uom, "commercial", "uniT_TEXT", "commercial")
        }
        return result
    }

    handleChangeServiceLine(event, index) {
        const {
            local_t_GR_SERVICE,
            local_t_GR_SERVICELINE,
            serviceItemNo
        } = this.state

        const { onSumTotalReceivedValue, onHandleChangeServiceLine, is_contract } = this.props

        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        //check date
        if (target.className) {
            if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    }
                }
            }
        }
        let _serviceline = local_t_GR_SERVICELINE.filter((data) => {
            return (data.service_item_no && (data.service_item_no + '') === (serviceItemNo + ''))
            //return (data.service_item_no && (data.service_item_no + '') === (serviceItemNo + '')) || ((data.running != '' || data.running == 0) && data.checked)
        })
        if (_serviceline) {
            this.setState({
                serviceline_render: _serviceline
            })
            let grserviceItem = local_t_GR_SERVICE.find(f => f.service_item_no == value)
            if (grserviceItem) {
                this.setState({
                    overall_limit: grserviceItem.overall_limit,
                    ol_currency: grserviceItem.ol_currency,
                    expected_value: grserviceItem.expected_value,
                    ev_currency: grserviceItem.ev_currency,
                    actual_value: grserviceItem.actual_value,
                    av_currency: grserviceItem.av_currency,
                    total_received_value: grserviceItem.total_received_value,
                    trv_currency: grserviceItem.trv_currency
                })
            }
        }

        if (name === "receive_qty" && is_contract == false) {
            let current = local_t_GR_SERVICELINE[index]
            if (current[name] != value) {
                let objSerLine = local_t_GR_SERVICELINE[index]
                if (objSerLine) {
                    if (objSerLine.remaining_qty) {
                        let _remaining_qty = utilityHelper.parseFloat(objSerLine.remaining_qty)
                        let _receive_qty = utilityHelper.parseFloat(value)
                        if (_receive_qty > _remaining_qty) {
                            msg.error('Receive Qty มากกว่า Remaining Qty กรุณาตรวจสอบข้อมูล')
                        }
                        else if (_receive_qty < _remaining_qty) {
                            msg.warning('Receive Qty น้อยกว่ายอด Remaining Qty')
                        }
                    }
                }
            }
        }


        if (valid) {
            let current = local_t_GR_SERVICELINE[index]
            if (current[name] != value) {
                //current[name] = value

                if (onSumTotalReceivedValue && onHandleChangeServiceLine) {
                    onHandleChangeServiceLine(name, value, index)
                    onSumTotalReceivedValue(serviceItemNo)
                }
            }
        } else {
            return
        }
    }

    loadServiceLineByPopupServiceline() {
        const { local_t_GR_SERVICELINE } = this.state
        const { serviceItemNo } = this.state

        // let _serviceline = local_t_GR_SERVICELINE.filter((data) => {
        //     return (data.service_item_no && data.service_item_no + '' === serviceItemNo + '') || ((data.running != '' || data.running == 0) && data.checked)
        // })
        let _serviceline = local_t_GR_SERVICELINE.filter((data) => {
            return (data.service_item_no && data.service_item_no + '' === serviceItemNo + '')
        })


        if (_serviceline || _serviceline.length === 0) {
            this.setState({
                serviceline_render: _serviceline
            })
        }
    }

    setServiceLineModal(index = "") {
        let {
            serviceItemNo,
            local_t_GR_SERVICE,
            local_t_GR_SERVICELINE
        } = this.state

        const { docementType, is_contract } = this.props


        let selectItemGR_Service = local_t_GR_SERVICE.filter((data) => {
            return data.service_item_no && (data.service_item_no + '') === (serviceItemNo + '')
        })

        let viewmode = false
        let lastLineNo = this.getLastServiceLineNo(serviceItemNo).toString()

        let serviceL = local_t_GR_SERVICELINE[index]
        if (serviceL) {
            viewmode = serviceL.remaining_qty == 0 ? true : false
        }

        let data = {
            //index: index == "" ? serviceItemNo : index, 
            index: index,
            serviceItemNo: serviceItemNo,
            viewmode: viewmode,
            lastLineNo: lastLineNo,
            docementType: docementType,
            is_contract: is_contract
        }

        window.emitter.emit(EVENT_CURRENT_SERVICELINE_SELECTED, {
            selectItemGRService: selectItemGR_Service,
            serviceLineModal: data
        })

    }
    getLastServiceLineNo(service_item_no) {
        let { t_GR_SERVICELINE } = this.props
        console.log("getLastServiceLineNo");
        
        let lastNo = 0
        t_GR_SERVICELINE.map((serviceLine, _index) => {

            if (serviceLine.service_item_no === service_item_no && utilityHelper.parseInt(serviceLine.service_line_no) > utilityHelper.parseInt(lastNo)) {
                lastNo = serviceLine.service_line_no
            }
        })
        return (Number(lastNo))
    }


    deleteServiceLine(index) {
        this.props.deleteGRServiceLine(index)
    }

    setHeaderCheckAll(local_serviceItemNo) {
        let {
            serviceItemNo,
            local_t_GR_SERVICELINE
        } = this.state

        serviceItemNo = serviceItemNo && local_serviceItemNo == serviceItemNo ? serviceItemNo : local_serviceItemNo

        let isCheckAllRows = false
        const { onSumTotalReceivedValue } = this.props

        let rowCount = local_t_GR_SERVICELINE == null ? 0 :
            local_t_GR_SERVICELINE.filter(f => f.service_item_no == serviceItemNo).length //จำนวนรายการบริการทั้งหมด

        if (rowCount > 0) {
            let rowCheckedCount = local_t_GR_SERVICELINE && local_t_GR_SERVICELINE
                .filter(f => (f.checked == 1 || f.checked == true)
                    && f.service_item_no == serviceItemNo)
                .length
            //ถ้ากด checkall ทุกรายการ
            isCheckAllRows = rowCount == rowCheckedCount
        }

        this.setState({ serviceline_checkall: isCheckAllRows })

        if (onSumTotalReceivedValue) {
            onSumTotalReceivedValue(serviceItemNo)
        }
    }

    handleChangePage(event, newPage, pageName) {
        this.setState({
            [pageName]: newPage
        })
    }

    handleChangeRowsPerPage(event, pageName, rowsPerPageName) {
        this.setState({
            [rowsPerPageName]: +event.target.value,
            [pageName]: 0
        })
    }

    render() {
        const {
            viewMode,
            docTypeServiceLine,
            is_contract,
            setOverAllLimit
        } = this.props

        const {
            serviceItemNo,
            showServiceLine,
            local_t_GR_SERVICE,
            local_t_GR_SERVICELINE,
            head_serviceLine,
            serviceline_checkall,
            serviceline_render,
            orderBy_serviceLine,
            order_serviceLine,
            page_serviceLine,
            rowsPerPage_serviceLine,
        } = this.state
        //let viewModeAdd = serviceline_render.length > 0 && showServiceLine && serviceline_render[0].running ? true : viewMode;
        // console.log("ServiceLineList.render()")
        // console.log("local_t_GR_SERVICE:")
        // console.log(local_t_GR_SERVICE)
        // console.log("local_t_GR_SERVICELINE:")
        // console.log(local_t_GR_SERVICELINE)
        // console.log("serviceItemNo:", serviceItemNo)
        // console.log("serviceline_render:")
        // console.log(serviceline_render)
        

        return (
            <React.Fragment>
                {(local_t_GR_SERVICE.length > 0
                    && showServiceLine
                )
                    && (<div className="rrs-detail py-1 px-5">
                        <div className="sp-table-container">
                            <div className="row rrs-table-hdr-wrap">
                                <div className="col-md-2">
                                    <h2 className="rrs-table-hdr">Service Line</h2>
                                </div>
                            </div>
                            <div className="row sp-pagination-control-top">
                                <Div className="col-auto create-button" doctype={docTypeServiceLine} tagid="gr.serviceline.add" viewMode={viewMode}>
                                    <a href="#" className="sp-bt-addmore" onClick={() => this.setServiceLineModal()} data-toggle="modal" data-target="#serviceLineModal">
                                        <i className="icon btn-plus" />
                                        <span>เพิ่ม</span>
                                    </a>
                                </Div>
                            </div>

                            <div className="row no-gutters sp-table-content">
                                <Table aria-labelledby="tableTitle" className="sp-table table rrs-table">
                                    <TableHead className="text-center">
                                        <TableRow className="sp-table-header">
                                            <TableCell padding="checkbox" className="th-table">
                                                <CheckerBox
                                                    checked={serviceline_checkall}
                                                    onChange={(event) => this.handleSelectAllClick(event, local_t_GR_SERVICELINE, "t_GR_SERVICELINE", "selected_serviceLine")}
                                                    inputProps={{ "aria-label": "select all item" }}
                                                    color="primary"
                                                    viewMode={viewMode}
                                                />
                                            </TableCell>
                                            {head_serviceLine.map((row, index) => (

                                                ((row.id === "delete" && is_contract == false && setOverAllLimit == 0) || (row.id === "remaining_qty" && row.iscontract !== is_contract)) ? null : <TableCell
                                                    className="th-table text-center"
                                                    tagid={row.tagid}
                                                    doctype={docTypeServiceLine}
                                                    key={row.id}
                                                    padding={row.disablePadding ? "none" : "default"}
                                                    sortDirection={orderBy_serviceLine === row.id ? order_serviceLine : false}
                                                    //style={{ width: row.width }}
                                                    width={row.width}
                                                >
                                                    {!row.disableSort && (<TableSortLabel
                                                        active={orderBy_serviceLine === row.id}
                                                        direction={order_serviceLine}
                                                        onClick={() => tableHelper.handleRequestSort("order_serviceLine", "orderBy_serviceLine", row.id)}
                                                    >
                                                        <div className="th-text text-center">{row.label}</div>
                                                        {orderBy_serviceLine === row.id ? (
                                                            <span
                                                                style={{
                                                                    border: 0,
                                                                    clip: "rect(0 0 0 0)",
                                                                    height: 1,
                                                                    margin: -1,
                                                                    overflow: "hidden",
                                                                    padding: 0,
                                                                    position: "absolute",
                                                                    top: 20,
                                                                    width: 1
                                                                }}
                                                            >
                                                                {order_serviceLine === "desc"
                                                                    ? "sorted descending"
                                                                    : "sorted ascending"}
                                                            </span>
                                                        ) : null}
                                                    </TableSortLabel>)}
                                                    {row.disableSort && (
                                                        <div className="th-text text-center">{row.label}</div>
                                                    )}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {tableHelper.stableSort(serviceline_render, tableHelper.getSorting(order_serviceLine, orderBy_serviceLine))
                                            .slice(page_serviceLine * rowsPerPage_serviceLine, page_serviceLine * rowsPerPage_serviceLine + rowsPerPage_serviceLine)
                                            .map((row, index) => {
                                                const isItemSelected = (row.checked == 1 ? true : false);
                                                const labelId = `enhanced-table-checkbox-${index}`;

                                                //let index_start = (this.state.page_serviceLine * this.state.rowsPerPage_serviceLine) + index;
                                                // console.log("==========================")
                                                // console.log("Number(row.service_item_no)",Number(row.service_item_no))
                                                // console.log("Number(serviceItemNo)",Number(serviceItemNo))

                                                if ((Number(row.service_item_no) === Number(serviceItemNo)) || ((row.running != '' || row.running === 0) && row.checked)) {
                                                    //console.log("Number(row.service_item_no) === Number(serviceItemNo)")
                                                    //let grItem = t_GR_SERVICE.find(f => f.service_item_no == this.state.items)
                                                    //let docType = utilityHelper.getDocType(po_no, grItem.a, grItem.i, grItem.material, grItem.overall_limit)
                                                    let index_start = local_t_GR_SERVICELINE
                                                        .findIndex(f => f.service_item_no == row.service_item_no
                                                            && f.service_line_no == row.service_line_no)

                                                    let deleterowserviceline = local_t_GR_SERVICELINE[index_start] ? local_t_GR_SERVICELINE[index_start] : row

                                                    return (
                                                        <TableRow
                                                            hover
                                                            role="checkbox"
                                                            aria-checked={isItemSelected}
                                                            tabIndex={-1}
                                                            key={index}
                                                            selected={isItemSelected}
                                                        >
                                                            {is_contract == false && (
                                                                <TableCell padding="checkbox">
                                                                    <CheckerBox
                                                                        key={`serviceline_${index_start}_${row.service_item_no}_${row.service_line_id}`}
                                                                        checked={isItemSelected}
                                                                        inputProps={{ "aria-labelledby": labelId }}
                                                                        color="primary"
                                                                        onChange={(event) => this.handleClick(event, index_start, "selected_serviceLine", row.service_item_no, row.service_line_no)}
                                                                        //disabled={Number(row.remaining_qty) === 0}
                                                                        viewMode={viewMode || Number(row.remaining_qty) === 0}
                                                                    />
                                                                </TableCell>
                                                            )}
                                                            {is_contract == true && (
                                                                <TableCell padding="checkbox">
                                                                    <CheckerBox
                                                                        key={`serviceline_${index_start}_${row.service_item_no}_${row.service_line_id}`}
                                                                        checked={isItemSelected}
                                                                        inputProps={{ "aria-labelledby": labelId }}
                                                                        color="primary"
                                                                        onChange={(event) => this.handleClick(event, index_start, "selected_serviceLine", row.service_item_no, row.service_line_no)}
                                                                        //disabled={Number(row.remaining_qty) === 0}
                                                                        viewMode={viewMode}
                                                                    />
                                                                </TableCell>
                                                            )}

                                                            {(is_contract == true || setOverAllLimit > 0) && (
                                                                <TableCell className="action-icon" tagid="gr.sevice_line.btndelete" doctype={docTypeServiceLine}  >
                                                                    <button
                                                                        className="btn"
                                                                        onClick={() => { this.props.onHandleDeleteServiceLine("t_GR_SERVICELINE", deleterowserviceline) }}
                                                                        disabled={viewMode}
                                                                    >
                                                                        <i className="icon btn-trash" />
                                                                    </button>
                                                                </TableCell>
                                                            )}

                                                            <TableCell className="action-icon" tagid="gr.sevice_line.btndetail" doctype={docTypeServiceLine}  >
                                                                <a href="#" onClick={() => this.setServiceLineModal(index_start)} data-toggle="modal" data-target="#serviceLineModal">
                                                                    <i className="icon bt-edit" />
                                                                </a>
                                                            </TableCell>
                                                            <TableCell tagid="gr.sevice_line.service_line_no" doctype={docTypeServiceLine}><label className="label-full text-grid">{row.service_line_no}</label></TableCell>
                                                            <TableCell tagid="gr.sevice_line.Short_Text" doctype={docTypeServiceLine} >
                                                                {(Number(row.checked) == 1) && (
                                                                    <Input
                                                                        key={`serviceline_${index_start}_${row.service_item_no}_${row.service_line_id}_${row.short_text}`}
                                                                        tagid="gr.sevice_line.Short_Text"
                                                                        doctype={docTypeServiceLine}
                                                                        name={"short_text"}
                                                                        defaultValue={row.short_text}
                                                                        id="short_text"
                                                                        onBlur={(event) => this.handleChangeServiceLine(event, index_start)}
                                                                        viewMode={viewMode}
                                                                        maxlength="40"
                                                                    />
                                                                )}
                                                                {((Number(row.checked) !== 1) /*|| (row.checked === 1 && transaction.GR.overall_limit === null)*/) && (
                                                                    <label className="label-full text-grid">{row.short_text}</label>
                                                                )}
                                                            </TableCell>
                                                            <TableCell className="text-right" tagid="gr.service_line.qty" doctype={docTypeServiceLine}><label className="label-full text-grid">{numeral(row.qty).format('0,0.000')}</label></TableCell>
                                                            {is_contract == false && (
                                                                <TableCell className="text-right" tagid="gr.service_line.remaining_qty" doctype={docTypeServiceLine}>
                                                                    <label className="label-full text-grid">{numeral(row.remaining_qty).format('0,0.000')}</label>
                                                                </TableCell>
                                                            )}
                                                            <TableCell className="text-right" tagid="gr.sevice_line.receive_qty" doctype={docTypeServiceLine} >
                                                                {(Number(row.checked) == 1) && (
                                                                    <InputDecimal
                                                                        key={`serviceline_${index_start}_${row.service_item_no}_${row.service_line_id}_${row.receive_qty}`}
                                                                        tagid="gr.sevice_line.receive_qty"
                                                                        doctype={docTypeServiceLine}
                                                                        type="text"
                                                                        name="receive_qty"
                                                                        pattern="[0-9.,]*"
                                                                        defaultValue={row.receive_qty ? (numeral(row.receive_qty).format('0,0.000')) : ""}
                                                                        className="form-control text-right"
                                                                        id="receive_qty"
                                                                        onBlur={(event) => this.handleChangeServiceLine(event, index_start)}
                                                                        inputMode="decimal"
                                                                        step="0,0.000"
                                                                        floatingPoint={3}
                                                                        viewMode={viewMode}
                                                                    />
                                                                )}
                                                                {(Number(row.checked) !== 1) && (
                                                                    <label className="label-full text-grid">{numeral(row.receive_qty).format('0,0.000')}</label>
                                                                )}
                                                            </TableCell>
                                                            <TableCell className="text-center" tagid="gr.service_line.unit" doctype={docTypeServiceLine}>
                                                                {(Number(row.checked) == 1) && (
                                                                    <DropDownList
                                                                        key={`serviceline_${index_start}_${row.service_item_no}_${row.service_line_id}_${row.unit}`}
                                                                        tagid="gr.service_line.unit"
                                                                        doctype={docTypeServiceLine}
                                                                        name="unit"
                                                                        className="text-left"
                                                                        options={this.getUnitUOM()}
                                                                        selected={row.unit}
                                                                        onSelectChanged={(event) => this.handleChangeServiceLine(event, index_start)}
                                                                        viewMode={viewMode}
                                                                    >
                                                                    </DropDownList>)}
                                                                {(Number(row.checked) !== 1) && (
                                                                    <label className="label-full text-grid">{row.unit}</label>
                                                                )}
                                                            </TableCell>
                                                            <TableCell className="text-right" tagid="gr.sevice_line.Gross_Price" doctype={docTypeServiceLine}>
                                                                {(Number(row.checked) == 1) && (
                                                                    <InputDecimal
                                                                        key={`serviceline_${index_start}_${row.service_item_no}_${row.service_line_id}_${row.gross_price}`}
                                                                        tagid="gr.sevice_line.Gross_Price"
                                                                        doctype={docTypeServiceLine}
                                                                        type="text"
                                                                        name="gross_price"
                                                                        pattern="[0-9.,]*"
                                                                        defaultValue={row.gross_price ? (numeral(row.gross_price).format('0,0.00')) : ""}
                                                                        className="form-control text-right"
                                                                        id="gross_price"
                                                                        onBlur={(event) => this.handleChangeServiceLine(event, index_start)}
                                                                        inputMode="decimal"
                                                                        step="0,0.00"
                                                                        viewMode={viewMode}
                                                                    />
                                                                )}
                                                                {((Number(row.checked) !== 1) /*|| (row.checked === 1 && transaction.GR.overall_limit === null)*/)
                                                                    && (
                                                                        <label className="label-full text-grid">{numeral(row.gross_price).format('0,0.00')}</label>
                                                                    )}
                                                            </TableCell>
                                                            <TableCell className="text-center" tagid="gr.sevice_line.currency" doctype={docTypeServiceLine}><label className="label-full text-grid text-center">{row.currency}</label></TableCell>

                                                        </TableRow>
                                                    )
                                                }

                                            })}
                                    </TableBody>
                                </Table>
                            </div>
                        </div>
                    </div>)}
                {serviceline_render
                    && (serviceline_render.length > 0
                        && serviceline_render[0].service_item_no
                        && showServiceLine)
                    && (
                        <div className="rrs-detail pt-0 pb-1 px-5">
                            <TablePagination
                                className="pager"
                                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                component="div"
                                count={serviceline_render.length}
                                rowsPerPage={rowsPerPage_serviceLine}
                                page={page_serviceLine}
                                backIconButtonProps={{
                                    "aria-label": "previous page"
                                }}
                                nextIconButtonProps={{
                                    "aria-label": "next page"
                                }}
                                onChangePage={(event, newPage) => this.handleChangePage(event, newPage, "page_serviceLine")}
                                onChangeRowsPerPage={(event) => this.handleChangeRowsPerPage(event, "page_serviceLine", "rowsPerPage_serviceLine")}
                            />
                        </div>
                    )}
            </React.Fragment>
        )
    }
}
const mapStateToProps = state => {
    const { MainRedux } = state
    return {
        t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: MainRedux.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
    }
}
export default connect(
    mapStateToProps
)(ServiceLineList);
//export default ServiceLineList